
import React from 'react';
import { useUserNotifications } from '@/hooks/useUserNotifications';
import NotificationModal from './NotificationModal';
import { useAuth } from '@/context/AuthContext';
import Logger from '@/utils/logger';

const UserNotificationDisplay: React.FC = () => {
  const { user } = useAuth();
  const { notifications } = useUserNotifications();

  // Filter to only show modal notifications globally
  const modals = notifications?.filter(n => n.type === 'modal') || [];

  

  return (
    <>
      {/* Development Debug Info */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{
          fontSize: '10px', 
          color: 'gray',
          position: 'fixed',
          top: '0',
          right: '0',
          background: 'rgba(255,255,255,0.9)',
          padding: '4px',
          zIndex: 9999,
          border: '1px solid #ddd'
        }}>
          Debug: Modal notifications: {modals?.length || 0} | User: {user ? 'Yes' : 'No'}
        </div>
      )}

      {/* Modals - shown as overlays globally */}
      {modals.map(notification => {
        
        return (
          <NotificationModal 
            key={notification.id} 
            title={notification.title} 
            message={notification.message} 
          />
        );
      })}
    </>
  );
};

export default UserNotificationDisplay;
